export default function Privacy() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-2xl font-bold text-gray-900 cursor-pointer">ターサン</a>
            <a href="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">
              ホームに戻る
            </a>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-24 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">プライバシーポリシー</h1>
          
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の取り扱いについて</h2>
              <p>
                合同会社Tarsan（以下「当社」）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」）を遵守すると共に、以下のプライバシーポリシー（以下「本ポリシー」）に従い、適切な取扱い及び保護に努めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 個人情報の定義</h2>
              <p>
                本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）、もしくは個人識別符号が含まれる情報を意味するものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. 個人情報の収集方法</h2>
              <p>
                当社は、お客様が当社サービスを利用される際に、以下の個人情報を収集することがあります：
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
                <li>氏名</li>
                <li>メールアドレス</li>
                <li>電話番号</li>
                <li>住所</li>
                <li>お問い合わせ内容</li>
                <li>その他、サービス提供に必要な情報</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. 個人情報の利用目的</h2>
              <p>
                当社は、収集した個人情報を以下の目的で利用いたします：
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
                <li>商品の発送及びサービスの提供</li>
                <li>お客様からのお問い合わせへの対応</li>
                <li>当社サービスに関する情報のご案内</li>
                <li>キャンペーン、アンケート等の実施</li>
                <li>サービスの改善及び新サービスの開発</li>
                <li>利用規約等に違反する行為への対応</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. 個人情報の第三者提供</h2>
              <p>
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
                <li>法令に基づく場合</li>
                <li>人の生命、身体又は財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関等の法令の定める事務に協力する必要がある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. 個人情報の安全管理</h2>
              <p>
                当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、個人情報の取扱いを委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. 個人情報の開示・訂正・削除</h2>
              <p>
                お客様は、当社に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止）に関して、当社問合わせ窓口に申し出ることができます。その際、当社はお客様ご本人を確認させていただいた上で、合理的な期間内に対応いたします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Cookie（クッキー）の使用について</h2>
              <p>
                当社のウェブサイトでは、お客様により良いサービスを提供するため、Cookieを使用することがあります。Cookieとは、ウェブサーバーからお客様のブラウザに送信される小さなテキストファイルで、お客様のコンピュータのハードディスクに保存されます。お客様はブラウザの設定によりCookieの受け取りを拒否することができますが、その場合、当社サービスの一部機能がご利用いただけない場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. プライバシーポリシーの変更</h2>
              <p>
                当社は、法令の変更等に伴い、本ポリシーを変更することがあります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. お問い合わせ窓口</h2>
              <p>
                個人情報の取扱いに関するお問い合わせは、以下の窓口までご連絡ください：
              </p>
              <div className="mt-4 p-6 bg-stone-50 rounded-lg">
                <p className="font-bold text-gray-900 mb-2">合同会社Tarsan</p>
                <p>個人情報保護管理者</p>
                <p className="mt-2">メール: privacy@tarsan.com</p>
                <p>電話: 03-1234-5678</p>
              </div>
            </section>

            <section className="pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">制定日：2025年1月1日</p>
              <p className="text-sm text-gray-500">最終改定日：2025年1月1日</p>
              <p className="text-sm text-gray-500 mt-4">合同会社Tarsan</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
